<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
    <router-view />
  </div>
</template>
<script>
export default {
 
}
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
  font-family: 'Source Han Sans SC' !important;

}

*::-webkit-scrollbar {
  display: none;
}

ul,
li {
  list-style: none;
}

html,
body {
  height: 100%;
  // overflow: auto;
  // margin: 0;
}

html {
  overflow-y: auto;
}

#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  // padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
